import { api } from "@/lib/api";

let cache = null;
export const getWaPublic = () => {
    if (!cache) cache = api.get("/whatsapp/public").then((r) => r.data).catch(() => ({ number: "" }));
    return cache;
};

export const waDigits = (phone = "") => {
    let d = String(phone).replace(/\D/g, "");
    if (d.startsWith("00")) d = d.slice(2);
    if (d.startsWith("0") && (d.length === 9 || d.length === 10)) d = "355" + d.slice(1);
    return d;
};

export const waLink = (phone, text = "") =>
    `https://wa.me/${waDigits(phone)}${text ? `?text=${encodeURIComponent(text)}` : ""}`;
